import { gql } from '@apollo/client';

/**
 * Keep a recommendation as one of the client's proposals.
 *
 * Idempotent: saving the same urlId again returns the existing row. A failure
 * with success false means nothing is stored under that id for this user — the
 * working copy expired (24 hours) before it was saved, so the run has to be
 * made again. The recommendation must belong to the user it is saved for, so
 * an advisor saves under the same `asClient` header the run was made with.
 */
export const SAVE_INVESTMENT_PROPOSAL = gql`
  mutation SaveInvestmentProposal($urlId: String!, $title: String, $notes: String) {
    saveInvestmentProposal(urlId: $urlId, title: $title, notes: $notes) {
      success
      message
      proposal {
        urlId
        source
        title
        actionType
        subjectSymbol
        subjectName
        goalId
        portfolioSymbol
        candidateSymbols
        runInputs
        createdAt
      }
    }
  }
`;

/**
 * Record WHY a trade is being made, before it is made.
 *
 * The backend's own "call it before executing" write: one security, the
 * decision on it, the reason, and the horizon the reason is for. It is what a
 * fund manager's trade proposal is finalised INTO — there is no fund-level
 * proposal object, and a thesis per leg is the record the platform then
 * monitors (checkpoints, invalidators, alerts).
 *
 * `horizon` is short | medium | long, which also sets how often the thesis is
 * checked. `decision` is lower-case: buy | sell.
 */
export const SAVE_TRADE_THESIS = gql`
  mutation SaveTradeThesis($input: TradeThesisInput!) {
    saveTradeThesis(input: $input) {
      success
      message
      thesisId
    }
  }
`;
